'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../v2/language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingComponent = function (_React$Component) {
  _inherits(LoadingComponent, _React$Component);

  function LoadingComponent() {
    _classCallCheck(this, LoadingComponent);

    return _possibleConstructorReturn(this, (LoadingComponent.__proto__ || Object.getPrototypeOf(LoadingComponent)).apply(this, arguments));
  }

  _createClass(LoadingComponent, [{
    key: 'getText',
    value: function getText() {
      return this.props.text ? (0, _translate.t)(this.props.text) : (0, _translate.t)('Loading');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { bsSize: 'small', show: this.props.show },
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'div',
            { className: 'div-center ' + sessionStorage.getItem('org') },
            _react2.default.createElement(_reactBootstrap.ProgressBar, { bsStyle: this.props.hasError ? 'danger' : null, striped: true, active: !this.props.hasError, now: 100 }),
            _react2.default.createElement(
              'h3',
              null,
              this.props.hasError ? (0, _translate.t)('Error ' + this.props.statusCode) : this.getText()
            )
          )
        )
      );
    }
  }]);

  return LoadingComponent;
}(_react2.default.Component);

LoadingComponent.propTypes = {
  hasError: _react2.default.PropTypes.bool,
  statusCode: _react2.default.PropTypes.string,
  text: _react2.default.PropTypes.string,
  show: _react2.default.PropTypes.bool
};
exports.default = LoadingComponent;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/LoadingComponent.js
// module id = 271
// module chunks = 0